import { cn } from '@shared/utils/cn';

interface SkeletonProps {
  className?: string;
  variant?: 'default' | 'circle' | 'text';
}

export const Skeleton = ({
  className,
  variant = 'default'
}: SkeletonProps) => (
  <div
    className={cn(
      "animate-pulse bg-dark-surface/50",
      variant === 'circle' && 'rounded-full',
      variant === 'text' && 'rounded-md h-4',
      variant === 'default' && 'rounded-lg',
      className
    )}
    aria-label="Loading..."
    role="status"
  />
);

export const TableSkeleton = ({ rows = 5 }: { rows?: number }) => (
  <div className="space-y-2" role="status" aria-label="Loading table data">
    {Array.from({ length: rows }).map((_, i) => (
      <Skeleton key={i} className="h-12 w-full" />
    ))}
  </div>
);

export const CardSkeleton = () => (
  <div
    className="border border-dark-border/20 rounded-xl p-4 space-y-3 bg-dark-surface/20"
    role="status"
    aria-label="Loading card content"
  >
    <Skeleton className="h-6 w-3/4" variant="text" />
    <Skeleton className="h-4 w-full" variant="text" />
    <Skeleton className="h-4 w-5/6" variant="text" />
  </div>
);

export const ListSkeleton = ({ items = 5 }: { items?: number }) => (
  <div className="space-y-2" role="status" aria-label="Loading list items">
    {Array.from({ length: items }).map((_, i) => (
      <div key={i} className="flex items-center space-x-3 p-3 rounded-lg">
        <Skeleton variant="circle" className="h-10 w-10" />
        <div className="flex-1 space-y-2">
          <Skeleton className="h-4 w-3/4" variant="text" />
          <Skeleton className="h-3 w-1/2" variant="text" />
        </div>
      </div>
    ))}
  </div>
);
